export default {
    lang: {
        name: 'Estimated value'
    }
}